var isPc = window.innerWidth >= 981;
var imagesList = document.querySelectorAll("#MainContent img");


for (var tempIndex = 0; tempIndex < imagesList.length; tempIndex++) {
  var tempImage = imagesList[tempIndex];
  if (!tempImage.getAttribute("src")) {
    tempImage.setAttribute(
      "src",
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="
    );
  }
}


function stopAllVideos() {
    const containers = document.querySelectorAll('.h1-grooming-scene');
    containers.forEach(function(container) {
        const video = container.querySelector('video');
        if (video && !video.paused) {
            container.classList.remove('playing');
            video.pause();
            video.currentTime = 0;
        }
    });
}

function playVideo(container, video) {
    container.classList.add('playing');
    video.currentTime = 0;
    video.play().catch(function(error) {
        console.log('视频播放失败:', error);
    });
}

function pauseVideo(container, video) {
    container.classList.remove('playing');
    video.pause();
    video.currentTime = 0;
}


    function openVideoModal() {
        const modal = document.getElementById('videoModal');
        const iframe = document.getElementById('videoFrame');
        
        // 设置视频源
        iframe.src = 'https://player.vimeo.com/video/1103103715?badge=0&autopause=0&player_id=0&app_id=58479&autoplay=1';                     
        
        modal.classList.add('active');
        
        document.body.style.overflow = 'hidden';
    }

    function closeVideoModal(event) {
  
        if (event && event.target !== event.currentTarget) {
            return;
        }
        
        const modal = document.getElementById('videoModal');
        const iframe = document.getElementById('videoFrame');
        
       
        iframe.src = '';
        
        // 隐藏弹窗
        modal.classList.remove('active');
        
        document.body.style.overflow = 'auto';
    }

    document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape') {
            closeVideoModal();
        }
    });
function pcPageInit() {

  new LazyLoad({
    elements_selector: "#MainContent img",
    data_src: "cbcn-src",
    data_srcset: "cbcn-srcset",
    threshold: "3000",
    callback_enter: function (element) { },
  });
  
  new LazyLoad({
    elements_selector: "#MainContent video",
    data_src: "cbcn-src",
    data_srcset: "cbcn-srcset",
    data_poster: "cbcn-poster",
    threshold: "3000",
    callback_enter: function (element) { },
  });




    new Swiper('.charintro', {
                // Optional parameters
                centeredSlides: true,
                effect: 'slide',
                speed: 800,
                
                // Responsive breakpoints
                breakpoints: {
                    // When window width is >= 768px
                    768: {
                        slidesPerView: 1,
                        spaceBetween: 15
                    },
                    // When window width is >= 1024px
                    1024: {
                        slidesPerView: 1,
                        spaceBetween: 60
                    }
                },

                // Pagination
                pagination: {
                    el: '.charintro-pagination',
                    clickable: true,
                    dynamicBullets: false,
                },

                // Navigation arrows
                navigation: {
                    nextEl: '.charintro-next',
                    prevEl: '.charintro-prev',
                },

    });



    // 初始化 Swiper - 比较轮播
    const h1comparisonswiper = new Swiper('.h1comparison-swiper', {
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        effect: 'slide',
        speed: 600,
        on: {
            slideChange: function () {
                // 更新选项卡按钮状态
                tabButtonsA.forEach((button, index) => {
                    if (index === this.activeIndex) {
                        button.classList.add('active');
                    } else {
                        button.classList.remove('active');
                    }
                });
                
                // 控制比较轮播中的视频播放
                const comparisonVideos = document.querySelectorAll('.h1comparison-swiper video');
                comparisonVideos.forEach((video, idx) => {
                    if (idx === this.activeIndex) {
                        video.play();
                    } else {
                        video.pause();
                    }
                });
            },
        }
    });

    // 获取比较轮播的选项卡按钮
    const tabButtonsA = document.querySelectorAll('.h1comparison-tab-button');

    // 比较轮播选项卡点击事件
    tabButtonsA.forEach((button, index) => {
        button.addEventListener('click', () => {
            // 切换到对应幻灯片
            h1comparisonswiper.slideTo(index);
            
            // 更新按钮状态
            tabButtonsA.forEach((btn, idx) => {
                if (idx === index) {
                    btn.classList.add('active');
                } else {
                    btn.classList.remove('active');
                }
            });
        });
    });

    // 初始化 Swiper - 360度轮播
    const h1360swiper = new Swiper('.h1360-swiper', {
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        effect: 'slide',
        speed: 600,
        on: {
            slideChange: function () {
                // 更新选项卡按钮状态
                tabButtons.forEach((button, index) => {
                    if (index === this.activeIndex) {
                        button.classList.add('active');
                    } else {
                        button.classList.remove('active');
                    }
                });
                
                // 控制360度轮播中的视频播放
                const h1360Videos = document.querySelectorAll('.h1360-swiper video');
                h1360Videos.forEach((video, idx) => {
                    if (idx === this.activeIndex) {
                        video.play();
                    } else {
                        video.pause();
                    }
                });
            },
        }
    });

    // 获取360度轮播的选项卡按钮
    const tabButtons = document.querySelectorAll('.h1360-tab-button');

    // 360度轮播选项卡点击事件
    tabButtons.forEach((button, index) => {
        button.addEventListener('click', () => {
            // 切换到对应幻灯片
            h1360swiper.slideTo(index);
            
            // 更新按钮状态
            tabButtons.forEach((btn, idx) => {
                if (idx === index) {
                    btn.classList.add('active');
                } else {
                    btn.classList.remove('active');
                }
            });
        });
    });




  new Swiper('.h1-certificate', {
              
      effect: 'slide',
      speed: 800,
      
      // Responsive breakpoints
      breakpoints: {                
          768: {
              slidesPerView: 1,
              spaceBetween: 20
          },                
          1024: {
              slidesPerView: 3,
              spaceBetween: 20
          }
      },

      // Pagination
      pagination: {
          el: '.h1-certificate-pagination',
          clickable: true,
          dynamicBullets: false,
      },

      // Navigation arrows
      navigation: {
          nextEl: '.h1-certificate-next',
          prevEl: '.h1-certificate-prev',
      },

      // 轮播切换时停止所有视频
      on: {
          slideChange: function() {
              stopAllVideos();
          }
      }
  });


      // 为所有视频容器添加事件监听
    const videoContainers = document.querySelectorAll('.h1-grooming-scene');
    
    videoContainers.forEach(function(container) {
        const video = container.querySelector('video');
        
        if (video) {
            // 鼠标进入时播放视频
            container.addEventListener('mouseenter', function() {
                playVideo(container, video);
            });
            
            // 鼠标离开时暂停视频
            container.addEventListener('mouseleave', function() {
                pauseVideo(container, video);
            });
            
            // 移动端点击播放/暂停
            container.addEventListener('click', function(e) {
                e.preventDefault();
                
                if (video.paused) {
                    playVideo(container, video);
                } else {
                    pauseVideo(container, video);
                }
            });
            
            // 触摸开始事件（移动端）
            container.addEventListener('touchstart', function(e) {
                e.preventDefault();
                
                if (video.paused) {
                    playVideo(container, video);
                } else {
                    pauseVideo(container, video);
                }
            });
            
            // 视频结束时重置状态
            video.addEventListener('ended', function() {
                container.classList.remove('playing');
                video.currentTime = 0;
            });
            
            // 确保视频加载完成
            video.addEventListener('loadeddata', function() {
                console.log('视频加载完成:', video.src);
            });
            
            // 视频加载错误处理
            video.addEventListener('error', function() {
                console.log('视频加载出错:', video.src);
            });
        }
    });






}

if (isPc) {
  window.onload = function () {
    // 这段代码的作用是：检测用户是否使用的是 Internet Explorer 浏览器（特别是 IE11 及更早版本），如果是，就不加载主内容，只显示一个提示或占位元素。否则就移除 loading 效果，正常加载内容。
    var UA = window.navigator.userAgent;
    if (
      (UA.indexOf("Trident") > -1 && UA.indexOf("rv:11.0") > -1) ||
      UA.indexOf("MSIE") > -1
    ) {
      // 移除 .main-content 元素
      var mainContent = document.querySelector(".main-content");
      if (mainContent) {
        mainContent.remove();
      }
      
      // 添加 cbcn-pc-flexCol 类到 .loadingWt .cbcn-loading-text
      var loadingText = document.querySelector(".loadingWt .cbcn-loading-text");
      if (loadingText) {
        loadingText.classList.add("cbcn-pc-flexCol");
      }
      return;
    } else {
      // 移除 .loadingWt 元素
      var loadingWt = document.querySelector(".loadingWt");
      if (loadingWt) {
        loadingWt.remove();
      }
    }

    pcPageInit();
  };
}